export default {
	json(val) {
		return JSON.stringify(val);
	}
};
